import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  image: {
    width: 400,
    height: 150,
  },
})
